import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { Component, inject, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { QuillMaterialComponent } from "@tt-lib/components/quill-material/quill-material.component";

export type TraceCreateGeneralinfoDialogData = {
  maxNameLength: number;
  maxDescriptionLength: number;
  isNew: boolean;
  name: string;
  desc: string;
}
export type TraceCreateGeneralinfoUpdateData = {
  name: string,
  desc: string
}

@Component({
  selector: 'tt-trace-create-generalinfo-dialog',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    A11yModule,
    QuillMaterialComponent
  ],
  templateUrl: './trace-create-generalinfo-dialog.component.html',
  styleUrls: ['./trace-create-generalinfo-dialog.component.scss'],
  standalone: true
})
export class TraceCreateGeneralinfoDialogComponent implements OnInit {

  public editorForm!: FormGroup;
  public data = inject<TraceCreateGeneralinfoDialogData>(MAT_DIALOG_DATA);

  constructor(
    private formBuilder: FormBuilder,
    private _dialogRef: MatDialogRef<TraceCreateGeneralinfoDialogComponent>,
    //@Inject(MAT_DIALOG_DATA) public data: TraceCreateGeneralinfoDialogData,
  ) {}

  ngOnInit(): void {
    this.editorForm = this.formBuilder.group({
      name: new FormControl(this.data.name ? this.data.name : '', Validators.maxLength(this.data.maxNameLength)),
      desc: new FormControl(this.data.desc ? this.data.desc : '',  {validators: [(control: AbstractControl) => { const l = this.getHtmlLength(control.value); if(l > this.data.maxDescriptionLength){control.markAsDirty();control.markAllAsTouched()}; return l <= this.data.maxDescriptionLength ? null : {maxlength: {requiredLength: this.data.maxDescriptionLength, actualLength: l}}}]})
    });
  }

  update(): TraceCreateGeneralinfoUpdateData {
    return { name: this.editorForm.controls['name'].value ? this.editorForm.controls['name'].value.trim() : '', desc: this.editorForm.controls['desc'].value ? this.editorForm.controls['desc'].value.trim() : '' }
  }

  get descLength() {
    return this.getHtmlLength(this.editorForm.controls['desc'].value);
  }
  
  /**
   * removing tags before calculating the length
   */
  getHtmlLength(htmlString: string) : number {
    const htmlObject = document.createElement('div');
    htmlObject.innerHTML = '<div>' + (htmlString? htmlString : '') + '</div>';
    return htmlObject.getElementsByTagName("div")[0].innerText.trim().length;
  }
}

